import { HttpClient } from '@angular/common/http';
import { LightingGroupDTO } from '@elight/client/data-access/models';
import { Observable } from 'rxjs';

import { Environment } from '@elight/client/shared/utility/common';

export class ApiService<T> {
    protected constructor(
        protected httpClient: HttpClient,
        protected env: Environment,
        protected resource: string,
        private parentResource?: string
    ) {}

    public fetch(id: string, parentId?: string) {
        const url = this.getBaseUrl(parentId);
        return this.httpClient.get(`${url}/${id}`) as Observable<T>;
    }

    public get(params: string = '', parentId?: string) {
        const url = this.getBaseUrl(parentId);
        const urlWithParams = params ? `${url}${params}` : url;
        return this.httpClient.get(urlWithParams) as Observable<Array<T>>;
    }

    public create(payload: Partial<T>, parentId?: string) {
        const url = this.getBaseUrl(parentId);
        return this.httpClient.post(`${url}`, payload);
    }

    public update(id: string, payload: Partial<T>, parentId?: string) {
        const url = this.getBaseUrl(parentId);
        return this.httpClient.put<LightingGroupDTO>(`${url}/${id}`, payload);
    }

    public patch(id: string, payload: Partial<T>, parentId?: string) {
        const url = this.getBaseUrl(parentId);
        return this.httpClient.patch(`${url}/${id}`, payload);
    }

    public delete(id: string, parentId?: string) {
        const url = this.getBaseUrl(parentId);
        return this.httpClient.delete(`${url}/${id}`);
    }

    protected getBaseUrl(parentId?: string) {
        return !!this.parentResource && !!parentId
            ? `${this.env.api.baseURL}/${this.parentResource}/${parentId}/${this.resource}`
            : `${this.env.api.baseURL}/${this.resource}`;
    }
}
